import React, { useEffect, useState } from "react";
import styled from "styled-components";

import { useParams } from "react-router";
import { useNavigate } from "react-router-dom";
import { useSelector, shallowEqual, useDispatch } from "react-redux";
import {
  SG_FETCH_GPT_WEB_CHAT,

  SG_ADD_GPT_RECOMMENDATION,
  SG_EDIT_GPT_RECOMMENDATION,
  SG_DELETE_GPT_RECOMMENDATION,
} from "constants/actions";
//
import {
  Icon,
  Message,
  Button,
  Header,
  List,
  Input,
  Confirm,
  TransitionablePortal,
  Segment,
} from "semantic-ui-react";
//
import { format } from "date-fns";
//
import Select from "react-select";
import { BasicErrorMessage } from "utilities/ErrorMessages";

import {  DataView } from "./DataRender";
import Params from "./Params";

//
const Details = ({ employee_record_value, setReload }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [templateId, setTemplateId] = useState(false);
  const [templateDetails, setTemplateDetails] = useState({
    name: null,
  });
  const [orgSelected, setOrgSelected] = useState([]);
  const [valueSelected, setValueSelected] = useState([]);

  const [formErrors, setFormErrors] = useState([]);
  const [pristine, setPristine] = useState(true);
  const [valueChanged, setValueChanged] = useState(false);
  const [portalOpen, setPortalOpen] = useState(false);

  function BackArrow() {
    navigate(`/app/gpt-web-chat`);
  }

  useEffect(() => {
    setTemplateId(id);
  }, [id]);

  useEffect(() => {
    if (templateId) {
      dispatch({
        type: SG_FETCH_GPT_WEB_CHAT,
        payload: { id: templateId },
      });
    }
  }, [dispatch, templateId]);

  const { get_gpt_web_chat } = useSelector(
    (state) => ({
      get_gpt_web_chat: state.gpt_web_chat,
    }),
    shallowEqual
  );

  useEffect(() => {
    if (get_gpt_web_chat?.[templateId]) {
      setTemplateDetails(get_gpt_web_chat?.[templateId]);
    }
  }, [get_gpt_web_chat, templateId]);

  useEffect(() => {
    if (get_gpt_web_chat?.created?.id) {
      navigate(`/app/gpt-web-chat/details/${get_gpt_web_chat?.created?.id}`);
    }
  }, [get_gpt_web_chat, navigate]);

  useEffect(() => {
    if (get_gpt_web_chat?.deleted) {
      setReload(Math.random());
      const timer1 = setTimeout(() => {
        navigate(`/app/gpt-web-chat`);
      }, 500);
      return () => clearTimeout(timer1);
    }
  }, [get_gpt_web_chat, navigate, setReload]);



  // function DeleteQuestion() {
  //   if (templateId) {
  //     dispatch({
  //       type: SG_DELETE_GPT_RECOMMENDATION,
  //       payload: {
  //         id: templateId,
  //       },
  //     });

  //     // navigate(`/app/gpt-recommendation?reload=true`)
  //   }
  // }
  // function UpdateQuestions() {
  //   setPristine(false)
  //   if (formErrors.length === 0) {
  //     if (templateId) {
  //       dispatch({
  //         type: SG_EDIT_SURVEY_STANDARD,
  //         payload: {
  //           id: templateId,
  //           organization: orgSelected?.id,
  //           name: templateDetails?.name,
  //           replace_by: templateDetails?.replace_by,
  //           employee_record_value: valueSelected?.id,
  //         }
  //       });
  //       navigate(`/app/gpt-recommendation/detail/${templateId}`)
  //     }
  //     setPristine(true)
  //   }
  // }

  useEffect(() => {
    const ErrorList = [];
    if (!templateDetails?.name) {
      ErrorList.push("Enter a Name");
    }
    if (!valueSelected?.id) {
      ErrorList.push("Select a Value Name");
    }
    if (!orgSelected?.id) {
      ErrorList.push("Select an Organization");
    }

    setFormErrors(ErrorList);
  }, [templateDetails, valueSelected, orgSelected, valueChanged]);

  // function ChangeFormValues(e, name) {
  //   // console.log(name, e.target.value)
  //   let _ques = templateDetails
  //   _ques[`${name}`] = e.target.value
  //   setTemplateDetails(_ques)
  //   setValueChanged(e.target.value + name)
  // }

  // function ChangeDomain(e) {

  //   setValueSelected(e)
  //   setValueChanged(e)
  // }

  // function ChangeOrg(e) {
  //   setOrgSelected(e)
  //   setValueChanged(e)
  // }

  // console.log(templateDetails);

  return (
    <>
      <Header as="h2">
        <Icon
          style={{ cursor: "pointer" }}
          onClick={BackArrow}
          name="arrow left"
        />
        {templateId
          ? `View Details of ${templateDetails?.id}`
          : "Add New List Value"}
      </Header>
      {formErrors.length > 0 && !pristine && (
        <Message
          negative
          //   onDismiss={clearErrors}
          header="We need these details!"
          list={formErrors}
        />
      )}
      <SectionDiv>
        <BasicErrorMessage />
      </SectionDiv>
      {templateId && (
        <SectionDiv>
          <Container>
            <List horizontal>
              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Name</List.Header>
                    {templateDetails?.name}
                  </ListContainer>
                </List.Content>
              </List.Item>
              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Tracking</List.Header>
                    {templateDetails?.token}
                  </ListContainer>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Employee</List.Header>
                    {templateDetails?.employee}
                  </ListContainer>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Create At</List.Header>
                    {templateDetails?.created_at &&
                      format(
                        new Date(templateDetails?.created_at),
                        "dd-MMM-yyyy hh:mm a"
                      )}
                  </ListContainer>
                </List.Content>
              </List.Item>

              <List.Item>
                <List.Content>
                  <ListContainer>
                    <List.Header>Updated At</List.Header>
                    {templateDetails?.updated_at &&
                      format(
                        new Date(templateDetails?.updated_at),
                        "dd-MMM-yyyy hh:mm a"
                      )}
                  </ListContainer>
                </List.Content>
              </List.Item>
            </List>
          </Container>
        </SectionDiv>
      )}
      <SectionDiv>
        <Params data={templateDetails?.params} />
      </SectionDiv>
     
      <SectionDiv>
        <DataView data={templateDetails?.interaction_history} />
      </SectionDiv>

      {/* <SectionDiv>
        <Button floated="right" color="red" onClick={DeleteQuestion}>
          Delete
        </Button>
      </SectionDiv> */}
    </>
  );
};

export default Details;

const SectionDiv = styled.div`
  padding: 10px 0px;
  margin: 10px 0px;
  margin-bottom: ${(props) => (props.lastSection === true ? "100px" : "20px")};
`;

const Container = styled.div`
  display: flex;
`;
const SingleRowContent = styled.div`
  display: flex;
  // justify-content: flex-start;
  flex-direction: row;
`;
const SectionCell = styled.div`
  padding: 10px 10px;
  min-width: 350px;
  display: flex;
  flex-direction: row;
`;

const LabelHead = styled.label`
  font-weight: 700;
  display: block;
`;

const ListContainer = styled.div`
  margin: 0px 25px;
  // padding: 0px 25px;
  // background-color: #dcdcdcdc;
`;
const FormRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.5em;
`;

const FormLabel = styled.div`
  padding: 0.5em 1em 0.5em 0;
  flex: 1;
`;

const FormInput = styled.div`
  flex: 2;
`;
